// @flow
import fastdom from 'fastdom';
import fastdomPromised from 'fastdom/extensions/fastdom-promised';

export default fastdom.extend(fastdomPromised);
